import { fork } from "redux-saga/effects";
import authFlowSaga from "./auth";

export default function* rootSaga() {
  yield fork(authFlowSaga);
}
